var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flux-cube',{ref:"cube",attrs:{"images":_vm.images,"size":_vm.size,"depth":_vm.size.width,"css":_vm.cubeCss}})}
var staticRenderFns = []

export { render, staticRenderFns }